module.exports = __webpack_public_path__ + "img/AK0090-GR.f22efb74.jpg";